import React, { useState, useEffect, useRef } from "react";
import ExtendedSelectField from "@src/stories/elements/ExtendedSelectField/ExtendedSelectField";
import ExtendedTextField from '@src/stories/elements/ExtendedTextField/ExtendedTextField';
import ExtendedTextareaField from "@src/stories/elements/ExtendedTextareaField/ExtendedTextareaField";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import { useCart } from "frontend/js/useShopifyCart";
import { error } from "console";

const AddToCartButton = ({
  quantity,
  variant,
  buttonLabel,
  product,
  message,
  email,
  senderName,
  recipientName,
  sendDate,
  setErrorMessage,
  disabled 
}) => {

  const [isLoading, setIsLoading] = useState(false);

  const { cart } = useCart();
  useEffect(() => {
    setIsLoading(false);
    setErrorMessage('')
  }, [cart])
;


  const dispatchCustomEvent = (eventName, detail) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  };

  window.addEventListener("add-to-cart-response", (event) => {
    const { success, error, id } = event.detail;
    if (success) {
      console.log(`Item ${id} added successfully.`);
      setErrorMessage('')
      setIsLoading(false);
    } else {
      setErrorMessage(error)
      setIsLoading(false)
      console.error(`Failed to add item ${id}: ${error}`);
    }
  });

  return (
      <>
        <input type="hidden" name="id" value={variant && variant.id} />

        <input type="hidden" name="quantity" value={quantity} />

        <div>
          <button
            className={`button button-primary`}
            disabled={isLoading || disabled}
            onClick={() => { 
              if (disabled) return;
              dispatchCustomEvent("add-to-cart", { id: variant.id, quantity: quantity, title: product.title, price: Number(product.price)/100,  
                isGiftCard: true,  
                message,
                email,
                senderName,
                recipientName,
                sendDate
              });
              setIsLoading(true);
            }}
          >
            {isLoading ? 'Adding To Cart...' : buttonLabel}
          </button>
        </div>

    
      </>
   
  );
};

const ProductGiftCardForm = ({ product, routes, translations, settings }) => {
  const { variants } = product;
  const { add_to_cart_url } = routes;
  console.log(settings);
  const { email_limit, gift_voucher_limit,recipient_name_limit, sender_name_limit } = settings;
  const [senderName, setSenderName] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sendDate, setSendDate] = useState(null);
  const [giftCardVariant, setGiftCardVariant] = useState(variants[0]);
  const [errorMessage, setErrorMessage] = useState(false);

  const isAddToCartDisabled =
    !senderName.trim() ||
    !recipientName.trim() ||
    !email.trim() ||
    !message.trim() ||
    !giftCardVariant ||
    !sendDate; 

  const options = variants.map(item => ({
    value: item.id,
    label: item.title
  }));
  
  return (
    (
    <>
    <div className="product-gift-card-form flex flex-col gap-8"> 
      
      <ExtendedTextField
          name='senderName'
          key='senderName'
          value={senderName}
          label='Sender Name'
          placeholder={`Sender Name`}
          className='flex-1'
          onChange={(e) => {
       
            setSenderName(e.target.value)
          }}
          maxCharacters={sender_name_limit}
          required
        />

      <ExtendedTextField
          name='recipientName'
          key='Recipient Name'
          value={recipientName}
          label='Recipient Name'
          placeholder={`Recipient Name`}
          className='flex-1'
          onChange={(e) => {
            setRecipientName(e.target.value)
          }}
          maxCharacters={recipient_name_limit}
          showCharactersLeft
          required
        />
      
       <ExtendedTextField
          name='emailAddress'
          key='Email Address'
          value={email}
          label='Recipient Email Address'
          placeholder={`Email Address`}
          className='flex-1'
          onChange={(e) => {
            setEmail(e.target.value)
          }}
          maxCharacters={email_limit}
          required
        />
        <div>
          <div className="product-gift-card-form-datepicker-label"> Send Voucher On This Date  </div> 
            <div className="product-gift-card-form-datepicker-container"> 

            <DatePicker   
              placeholderText={`Select Date`} 
              dateFormat="dd/MM/yyyy" 
              minDate={new Date()}
              onChange={(date) => {
                if (date) {
                  const formattedDate = format(date, 'yyyy-MM-dd');
                  setSendDate(formattedDate);
                } else {
                  setSendDate(null); 
                }
              }}
              selected={sendDate} 
              />

            <div className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"     onClick={(e) => {
              const input = e.currentTarget.closest('.product-gift-card-form-datepicker-container')?.querySelector('input');
              input?.focus(); }}style={{ top: "50%", transform: "translateY(-50%)"}}> <span className='icon icon-chevron-down text-[24px]'></span> </div>
          </div>
        </div>

        <ExtendedTextareaField
            name='gift_message'
            key={`gift_message`}
            label='Gift Voucher Message'
            value={message}
            maxCharacters={gift_voucher_limit}
            onChange={(e) => {
              setMessage(e.target.value)
            }}
            showCharactersLeft
        />

    </div>
    <div className="flex flex-row items-center justify-between gap-[16px] py-2 pt-8">
        <div className="flex-1 w-1/2">
            <div className="font-[400] text-[14px] mb-2"> Value </div>
            <ExtendedSelectField
                name='giftCardVariant'
                options={options}
                value={giftCardVariant.id}
                required
                onChange={(e) => {
                  console.log(e);
                  const foundVariant = variants.find(variant => Number(variant.id) === Number(e.value));
                  console.log(foundVariant);
                  setGiftCardVariant(foundVariant);
                }}
            />
         </div>
         
             
        <div className="product___add-to-cart w-1/2 block mt-auto">

          <div className="add-to-cart-button">
              <AddToCartButton
                quantity={1}
                buttonType={"primary"}
                buttonLabel={translations?.add_to_cart}
                variant={giftCardVariant}
                product={product}
                setErrorMessage={setErrorMessage}
                isGiftCard
                message={message}
                email={email}
                senderName={senderName}
                recipientName={recipientName}
                sendDate={sendDate}
                disabled={isAddToCartDisabled}
              />
          </div>
        </div> 
    </div> 

    {errorMessage != '' && <div className="error-message text-red-500 mb-4">{errorMessage}</div>}
    {isAddToCartDisabled && (
      <div className="text-sm text-black mb-4">
        Please fill in all required details before adding to cart.
      </div>
    )}
    </>
    )

    
  );
};

export default ProductGiftCardForm;
